// src/components/LeaderboardWrapper.js

import React from 'react';
import { useParams } from 'react-router-dom';
import Leaderboard from './Leaderboard';

function LeaderboardWrapper() {
  const { campaignID } = useParams();

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-[100%]">
        <Leaderboard campaignID={campaignID} />
      </div>
    </div>
  );
}

export default LeaderboardWrapper;
